export const API_EXTERNAL_ENDPOINT = 'cottages/:id/seo-links'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/cottages/seo-links'
